import { useEffect, useState } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { Link } from "react-router-dom";
import Hambuger from "./hamburger";
import { headerDropdown } from "./constants";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { ArrowLeftIcon } from "../../icons/arrowLeftIcon";
// import { useModal } from "../../utils/demoProvider";
import { useNavigate } from "react-router-dom";
import {
  // About_US_Header_Icon,
  AI_Platform_Icon,
  Blogs_Header_Icon,
  DA_Header_Icon,
  // Career_Header_Icon,
  // Case_Study_Header_Icon,
  // Contact_Header_Icon,
  Data_Pipeline_Icon,
  Events_Webinars_Header_Icon,
  Inference_Icon,
  // FAQ_Header_Icon,
  Model_Fine_Icon,
  // Powered_By_AI_Icon,
  Products_Header_Img,
  Scalable_Integration_Icon,
  Services_Header_Img,
} from "../images";
import { useModal } from "../utils/demoProvider";

export const NewHeader = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const { openModal } = useModal();
  const navigate = useNavigate();

  useEffect(() => {
    setToggleMenu(false);
  }, []);

  return (
    <div
      className={`z-[1000] fixed w-screen max-w-full top-[1px] md:top-5 px-4`}
    >
      <nav className="bg-[#0000000A] backdrop-blur-xl border border-[#FFFFFF12] container mx-auto w-full flex justify-between py-2 xl:p-0 rounded-[100px] new-header">
        <div className="flex w-full justify-between mx-3 xl:py-1">
          <Link to="/" className="flex items-center p-2">
            <img
              src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1714663442/logo-ai-africa_feiiog.svg"
              alt="logo"
              //   className="h-[58px]"
              className="w-[140px] sm:w-[150px]"
            />
          </Link>
          <div className="hidden xl:flex ">
            {/* Products */}
            <div className="relative group py-6">
              <button
                type="button"
                className="flex gap-1 items-center focus:outline-none px-6"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  Products
                </p>
                <KeyboardArrowDown className="text-white" />
              </button>

              <div
                className="
                absolute top-[45px] lg:top-[55px] left-0 lg:-left-[200px] xl:-left-48 lg:w-[90vw] xl:w-[70vw]
                bg-white p-8 justify-between gap-4 rounded-xl
                opacity-0 translate-y-2 pointer-events-none
                group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto
                transition-all duration-300 ease-out
                flex z-[1000]
                "
              >
                <div className="flex-1 xl:flex-none xl:basis-[60%] flex flex-col gap-[24px]">
                  <Link to="/ai-platform">
                    <div className="flex gap-4">
                      <img
                        src={AI_Platform_Icon}
                        alt="ai platform icon"
                        className="w-[42px] h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">[AI] Platform</h5>
                        <p className="text-sm text-[#737373]">
                          Secure data infrastructure for collecting, processing
                          and delivering enterprise data to LLM and agentic
                          analytics applications.
                        </p>
                      </div>
                    </div>
                  </Link>

                  {/* <Link to="/">
                    <div className="flex gap-4">
                      <img
                        src={Powered_By_AI_Icon}
                        alt="plm icon"
                        className="w-[42px] h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">PoweredByAI</h5>
                        <p className="text-sm text-[#737373]">
                          Ready-to-deploy AI models and custom development for
                          African markets.
                        </p>
                      </div>
                    </div>
                  </Link> */}

                  <Link to="/data-assistant">
                    <div className="flex gap-4">
                      <img src={DA_Header_Icon} alt="data assistant icon" />
                      <div>
                        <h5 className="font-bold">Data Assistant</h5>
                        <p className="text-sm text-[#737373]">
                          Enterprise analytics agent powered by LLMs, delivering
                          explainable and actionable insights.
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="bg-[#DBECFF] p-6 flex flex-col items-center rounded-xl gap-4">
                  <img
                    src={Products_Header_Img}
                    className="w-[300px] h-[250px]"
                    alt="Data assistant header illustration"
                  />

                  <p className="text-xs">
                    Delivering production-ready AI models, a governed enterprise
                    platform, and LLMs built for African languages.
                  </p>
                </div>
              </div>
            </div>

            {/* Services */}
            <div className="relative group py-6">
              <button
                type="button"
                className="flex gap-1 items-center focus:outline-none px-6"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  Services
                </p>
                <KeyboardArrowDown className="text-white" />
              </button>

              <div
                className="
                  absolute top-[45px] lg:top-[55px] left-0 lg:-left-[310px] xl:-left-[250px] lg:w-[70vw]
                  bg-white p-8 justify-between rounded-xl
                  opacity-0 translate-y-2 pointer-events-none
                  group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto
                  transition-all duration-300 ease-out
                  flex
                "
              >
                <div className="flex-1 xl:flex-none xl:basis-[60%] flex flex-col gap-[24px]">
                  <Link to="/model-evaluation">
                    <div className="flex gap-4">
                      <img
                        src={Model_Fine_Icon}
                        alt="digital analytics header icon"
                        className="!w-[42px] !h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">
                          Model Customisation & Fine-Tuning
                        </h5>
                        <p className="text-sm text-[#737373]">
                          Tailored model adaptation, supervised fine-tuning, and
                          RLHF for African contexts.
                        </p>
                      </div>
                    </div>
                  </Link>

                  <Link to="/data-pipeline-and-evaluation">
                    <div className="flex gap-4">
                      <img
                        src={Data_Pipeline_Icon}
                        alt="for enterprise icon"
                        className="!w-[42px] !h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">
                          Data Pipeline & Evaluation
                        </h5>
                        <p className="text-sm text-[#737373]">
                          End-to-end data pipelines and structured evaluation
                          for high-quality, reliable AI systems.
                        </p>
                      </div>
                    </div>
                  </Link>

                  <Link to="/scalable-integrations">
                    <div className="flex gap-4">
                      <img
                        src={Scalable_Integration_Icon}
                        alt="for financial institutions icon"
                        className="!w-[42px] !h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">Scalable Integrations</h5>
                        <p className="text-sm text-[#737373]">
                          Enterprise-ready integrations that connect AI models
                          securely across platforms and workflows.
                        </p>
                      </div>
                    </div>
                  </Link>

                  <Link to="/ai-inference">
                    <div className="flex gap-4">
                      <img
                        src={Inference_Icon}
                        alt="for financial institutions icon"
                        className="!w-[42px] !h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">Secure AI Infrastructure</h5>
                        <p className="text-sm text-[#737373]">
                          Secure infrastructure for deploying, hosting, and
                          operating AI — fully under your control.
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="bg-[#DBECFF] p-6 flex flex-col w-full items-center rounded-xl gap-4">
                  <img
                    src={Services_Header_Img}
                    className="w-[300px] h-[250px]"
                    alt="solutions header illustration"
                  />
                  <div>
                    <p className="text-xs">
                      Building smarter AI with precise fine-tuning, strong data
                      operations, and scalable integrations.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* AI Academy */}
            <div className="relative group py-6">
              <a
                href="https://www.aiacademy.africa/"
                target="_blank"
                rel="noreferrer"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  AI Academy
                </p>
              </a>
            </div>

            {/* Resources */}
            <div className="relative group py-6">
              <button
                type="button"
                className="flex gap-1 items-center focus:outline-none px-6"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  Resources
                </p>
                <KeyboardArrowDown className="text-white" />
              </button>

              <div
                className="
                  absolute top-[45px] lg:top-[55px] lg:-left-[30px] xl:left-0 lg:w-max
                bg-white p-8 gap-8 rounded-xl
                  opacity-0 scale-95 pointer-events-none
                  group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto
                  transition-all duration-300 ease-out
                  "
              >
                <div className="flex-1 flex flex-col gap-4">
                  <Link to="/blog">
                    <div className="flex gap-4 items-center">
                      <img
                        src={Blogs_Header_Icon}
                        alt="Article header icon"
                        className="!w-[42px] !h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">Blogs</h5>
                      </div>
                    </div>
                  </Link>

                  {/* <Link to="/blog">
                    <div className="flex gap-4 items-center">
                      <img
                        src={Case_Study_Header_Icon}
                        alt="Article header icon"
                      />
                      <div>
                        <h5 className="font-bold">Case Studies</h5>
                      </div>
                    </div>
                  </Link> */}

                  <Link to="/events">
                    <div className="flex gap-4 items-center">
                      <img
                        src={Events_Webinars_Header_Icon}
                        alt="Event header icon"
                        className="!w-[42px] !h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">Events & Webinars</h5>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* About Us */}
            <div className="relative group py-6">
              <Link to="/about-us">
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out shadow-sm">
                  About Us
                </p>
              </Link>
            </div>
          </div>

          <button
            onClick={openModal}
            className="hidden md:block w-[118px] self-center rounded-[100px] py-3 text-[#010127] bg-white hover:bg-white/90 font-semibold text-center px-3 text-sm md:ml-2 transition-colors ease-in duration-300"
          >
            Book a Demo
          </button>
        </div>
        <button
          type="button"
          className="xl:hidden relative z-[200] px-2 cursor-pointer"
          onClick={() => setToggleMenu((prev) => !prev)}
          title="menu"
        >
          <Hambuger isOpen={toggleMenu} />
        </button>
        {toggleMenu && (
          <div
            className={`xl:hidden ${
              toggleMenu
                ? "opacity-100 translate-x-0"
                : "opacity-0 -translate-x-full"
            } transition-all flex-col items-start px-3 w-full left-0 right-0 bg-white shadow-xl fixed z-[200] top-[4rem] duration-1000 h-[95vh] overflow-y-auto pb-10 pt-4`}
          >
            <div className="w-full">
              {headerDropdown.map((link, i) => {
                const hasLists = Boolean(link.lists?.length);
                if (hasLists) {
                  return (
                    <Accordion
                      key={link.label}
                      elevation={0}
                      square
                      sx={{
                        borderBottom: "1px solid #e0e0e0",
                        "&:before": { display: "none" },
                        "&:last-of-type": { borderBottom: 0 },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${i}-content`}
                        id={`panel${i}-header`}
                      >
                        <span className="font-bold text-sm">{link.label}</span>
                      </AccordionSummary>

                      <AccordionDetails>
                        <div className="flex flex-col gap-4">
                          {link.lists.map((list) => (
                            <div
                              key={list.link}
                              onClick={() => {
                                setToggleMenu(false);
                                navigate(list.link);
                              }}
                              className="cursor-pointer"
                            >
                              <div
                                className={`flex ${
                                  i > 2 ? "items-center" : "items-start"
                                } gap-4`}
                              >
                                <img
                                  src={list.icon}
                                  className="w-[42px]"
                                  alt={list.text}
                                />
                                <div className="flex flex-col">
                                  {list.title && (
                                    <h5 className="text-[#2E2E37] text-sm font-bold">
                                      {list.title}
                                    </h5>
                                  )}
                                  {list.text && (
                                    <p className="text-xs">{list.text}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  );
                }
                return (
                  <>
                    {link.link.includes("https") ? (
                      <>
                        <a
                          href={link.link}
                          target="_blank"
                          rel="noreferrer"
                          key={link.label}
                          onClick={() => {
                            setToggleMenu(false);
                          }}
                          className="flex items-center justify-between px-4 py-3 cursor-pointer border-b border-[#e0e0e0]"
                        >
                          <span className="font-bold text-sm">
                            {link.label}
                          </span>
                        </a>
                      </>
                    ) : (
                      <div
                        key={link.label}
                        onClick={() => {
                          setToggleMenu(false);
                          navigate(link.link);
                        }}
                        className="flex items-center justify-between px-4 py-3 cursor-pointer border-b border-[#e0e0e0]"
                      >
                        <span className="font-bold text-sm">{link.label}</span>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};
